import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import schema from './userProfileForm.schema';

import { modalDataSelector } from '../../shared/modals/modals.selectors';
import { userPreferencesModal } from './modalNames';

import { YES_FLAG, NO_FLAG } from '../../shared/constants';

import { updateUserPreferences, hideUserPreferencesModal } from '../store/actions';
import { isUpdatingPreferencesSelector, userSelector } from '../store/selectors';

class UserProfileModal extends PureComponent {
  static propTypes = {
    user: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      sso: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      receiveEmailFlag: PropTypes.string.isRequired,
      hideDecimalsFlag: PropTypes.string.isRequired,
      negativeMinusFlag: PropTypes.string.isRequired,
      displayZeroFlag: PropTypes.string.isRequired,
      shadeGridFlag: PropTypes.string.isRequired,
    }).isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    updateUserPreferences: PropTypes.func.isRequired,
    isVisible: PropTypes.bool,
    hideModal: PropTypes.func.isRequired,
  };

  state = {
    formValues: {
      receiveEmailFlag: false,
      hideDecimalsFlag: NO_FLAG,
      negativeMinusFlag: NO_FLAG,
      displayZeroFlag: NO_FLAG,
      shadeGridFlag: NO_FLAG,
    },
    isDirty: false,
  };

  updateUserPreferences = (formData, { setSubmitting }) => {
    const { updateUserPreferences } = this.props;

    updateUserPreferences(({
      ...formData,
      receiveEmailFlag: formData.receiveEmailFlag ? YES_FLAG : NO_FLAG,
    }));
    setSubmitting(false);
  };

  renderModal = ({ formik, schema }) => {
    const {
      user,
      hideModal,
      isVisible,
      isSavingInProgress,
    } = this.props;

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="user-profile-modal"
        title="Preferences"
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save Changes"
        submitAction={formik.handleSubmit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit
          formContext={{
            user,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { user } = this.props;

    const formattedEntityToEdit = {
      ...user,
      receiveEmailFlag: user.receiveEmailFlag === YES_FLAG,
    };

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={formattedEntityToEdit}
        onSubmit={this.updateUserPreferences}
        render={this.renderModal}
      />
    );
  }
}

export default connect(
  state => ({
    user: userSelector(state),
    isSavingInProgress: isUpdatingPreferencesSelector(state),
    isVisible: modalDataSelector(state, userPreferencesModal).show,
  }),
  {
    updateUserPreferences,
    hideModal: hideUserPreferencesModal,
  })(UserProfileModal);
